import img1 from '../images/mark/pr-1.avif';
import img2 from '../images/mark/mk-header-777.png';
import img3 from '../images/mark/mk-slider-5.jpg';
import img4 from '../images/mark/mk-slider-1.jpg';



const dataBanner = [
    {
        id: 1,
        classAction: 'flat-slider flex',
        title: 'NEXTGen',
        title2: 'PR',
        title3: '',
        title4: 'Personalized PR Based on Digital Twin!',
        subtitle: 'NextGenPR combines cutting-edge digital twin technology with the power of generative AI to deliver personalized, data-driven PR strategies that resonate with your audience and drive meaningful engagement.',
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
    },
    
]

export default dataBanner;